(function () {
  function money(cents, format) {
    if (typeof window.vibeeMoneyDisplay === 'function') return window.vibeeMoneyDisplay(cents, format);
    if (typeof window.vibeeMoney === 'function') return window.vibeeMoney(cents, format);
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format || window.Shopify.money_format);
    }
    return (Number(cents || 0) / 100).toFixed(2) + ' TL';
  }

  // Hesaplanan tutarlar (set toplamı, tasarruf) kuruşsuz basılır (P59).
  function moneyFloor(cents) {
    if (typeof window.vibeeMoneyFloor === 'function') return window.vibeeMoneyFloor(cents);
    var s = String(Math.max(0, Math.floor(Number(cents || 0) / 100)));
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  function savingsPercent(listCents, subCents) {
    if (!listCents || listCents <= subCents) return 0;
    return Math.round(((listCents - subCents) * 100) / listCents);
  }

  function formatSavings(template, percent) {
    if (!template) return '%' + percent + ' tasarruf';
    return template
      .replace(/\{\{\s*percent\s*\}\}/g, String(percent))
      .replace(/%PERCENT%/g, String(percent))
      .replace(/%PERCENT/g, String(percent))
      .replace(/PERCENT/g, String(percent));
  }

  function updatePurchaseState(section, state) {
    section.querySelectorAll('[data-vibee-pdp-purchase-mode]').forEach(function (el) {
      el.value = state.mode;
    });
    section.querySelectorAll('[data-vibee-pdp-selling-plan-prop]').forEach(function (el) {
      el.value = state.sellingPlan;
      el.disabled = !state.sellingPlan;
    });
    section.querySelectorAll('[data-vibee-pdp-selling-plan]').forEach(function (el) {
      el.value = state.sellingPlan;
      el.disabled = !state.sellingPlan;
    });
    section.querySelectorAll('[data-vibee-pdp-bundle-id]').forEach(function (el) {
      el.value = state.bundleId;
      el.disabled = !state.bundleId;
    });
  }

  function safeSubmit(form) {
    if (form.requestSubmit) {
      form.requestSubmit();
      return;
    }
    var tmp = document.createElement('button');
    tmp.type = 'submit';
    tmp.style.display = 'none';
    form.appendChild(tmp);
    tmp.click();
    form.removeChild(tmp);
  }

  /**
   * @returns {Promise<object>}
   */
  function fetchCartJson() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_fetch_failed');
      return response.json();
    });
  }

  function isCartAddNetworkError(err) {
    return !!(err && err.code === 'network');
  }

  function isCartAddParseAfterSuccess(err) {
    return !!(err && err.code === 'parse' && err.responseOk);
  }

  function getCartPageUrl() {
    try {
      var node = document.getElementById('vibee-cart-drawer-config');
      if (node) {
        var cfg = JSON.parse(node.textContent || '{}');
        if (cfg.cartUrl) return cfg.cartUrl;
      }
    } catch (e) {}
    return '/cart';
  }

  function showAddFallbackNotice() {
    var el = document.querySelector('[data-vibee-cart-drawer-error]');
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    el.appendChild(document.createTextNode('✓ Sepete eklendi — '));
    var link = document.createElement('a');
    link.href = getCartPageUrl();
    link.textContent = 'Sepete git';
    link.className = 'vibee-cart-drawer__cart-link';
    el.appendChild(link);
    el.hidden = false;
    el.classList.add('is-visible');
    window.setTimeout(function () {
      el.hidden = true;
      el.classList.remove('is-visible');
    }, 6200);
  }

  /** Drawer open when available; otherwise header count + /cart notice. */
  function syncCartFeedback(cart, addResult) {
    var drawer = window.vibeeCartDrawer;
    if (drawer && typeof drawer.syncAfterAdd === 'function') {
      drawer.syncAfterAdd(cart, addResult);
      return;
    }
    if (drawer && typeof drawer.updateHeaderCartCount === 'function') {
      drawer.updateHeaderCartCount(cart);
    }
    if (drawer && typeof drawer.dispatchCartEvents === 'function') {
      drawer.dispatchCartEvents(cart);
    }
    showAddFallbackNotice();
  }

  /**
   * @param {RequestInit} init
   * @returns {Promise<object>}
   */
  function postCartAddJson(init) {
    return fetch('/cart/add.js', init)
      .then(function (response) {
        return response.text().then(function (text) {
          var body = {};
          if (text) {
            try {
              body = JSON.parse(text);
            } catch (parseErr) {
              var parseError = new Error('add_parse_failed');
              parseError.code = 'parse';
              parseError.responseOk = response.ok;
              throw parseError;
            }
          }
          if (!response.ok) {
            var httpErr = new Error('add_failed');
            httpErr.code = 'http';
            httpErr.body = body;
            throw httpErr;
          }
          return body;
        });
      })
      .catch(function (err) {
        if (err && err.code) throw err;
        var netErr = new Error('add_network_failed');
        netErr.code = 'network';
        throw netErr;
      });
  }

  /**
   * POST /cart/add.js → GET /cart.js → drawer or header/fallback feedback.
   * @param {RequestInit} init
   * @returns {Promise<object>}
   */
  function vibeeCartAddAndSync(init) {
    return postCartAddJson(init)
      .then(function (addResult) {
        return fetchCartJson().then(function (cart) {
          syncCartFeedback(cart, addResult);
          return cart;
        });
      })
      .catch(function (err) {
        if (isCartAddParseAfterSuccess(err)) {
          return fetchCartJson().then(function (cart) {
            syncCartFeedback(cart, null);
            return cart;
          });
        }
        throw err;
      });
  }

  /**
   * @param {HTMLFormElement} form
   * @returns {object}
   */
  function buildCartAddPayloadFromForm(form) {
    var fd = new FormData(form);
    var item = {
      id: Number(fd.get('id')),
      quantity: Number(fd.get('quantity') || 1),
    };
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    var properties = {};
    fd.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match && value !== '') properties[match[1]] = String(value);
    });
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function initPurchaseSelector(section, state, callbacks) {
    var purchaseRoot = section.querySelector('[data-vibee-pdp-purchase]');
    if (!purchaseRoot) return null;

    var dataNode = purchaseRoot.querySelector('[data-vibee-pdp-purchase-data]');
    var purchaseData = { variants: {} };
    try {
      if (dataNode) purchaseData = JSON.parse(dataNode.textContent);
    } catch (e) {
      console.error('vibee-pdp purchase JSON parse error', e);
    }

    var subRow = purchaseRoot.querySelector('[data-vibee-pdp-purchase-sub-row]');
    var modeRadios = purchaseRoot.querySelectorAll('[data-vibee-pdp-purchase-mode-radio]');
    var subPriceEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-sub-price]');
    var subCompareEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-sub-compare]');
    var subIntervalEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-interval]');
    var subPerksEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-perks]');
    var subBadgeEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-badge]');
    var onetimePriceEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-onetime-price]');
    var labels = {
      ctaSub: purchaseRoot.getAttribute('data-label-cta-sub') || 'DÜZENLİ TESLİMATLA AL',
      ctaOnetime: purchaseRoot.getAttribute('data-label-cta-onetime') || 'SEPETE EKLE',
      ctaSuffixMonthly: purchaseRoot.getAttribute('data-cta-suffix-monthly') || '/AY',
      ctaSuffixBimonthly: purchaseRoot.getAttribute('data-cta-suffix-bimonthly') || '/2 AY',
      savings: purchaseRoot.getAttribute('data-label-savings') || '%PERCENT tasarruf',
      perks: purchaseRoot.getAttribute('data-label-perks') || '',
      perksBi: purchaseRoot.getAttribute('data-label-perks-bi') || '',
      intervalMonthly: purchaseRoot.getAttribute('data-interval-monthly') || '/ ay',
      intervalBimonthly: purchaseRoot.getAttribute('data-interval-bimonthly') || '/ 2 ay'
    };
    var productHandle = purchaseRoot.getAttribute('data-product-handle') || '';

    function optionLabels() {
      return purchaseRoot.querySelectorAll('.vibee-pdp__purchase-option');
    }

    function syncSelectedCards() {
      optionLabels().forEach(function (label) {
        var input = label.querySelector('[data-vibee-pdp-purchase-mode-radio]');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
    }

    function getCheckedMode() {
      var checked = purchaseRoot.querySelector('[data-vibee-pdp-purchase-mode-radio]:checked');
      return checked && checked.value === 'subscription' ? 'subscription' : 'onetime';
    }

    function externalCheckoutUrl(variantData) {
      if (!variantData || !variantData.externalCheckout || !variantData.sku || !variantData.planRef) return '';
      var url = '/pages/duzenli-teslimat?sku=' + encodeURIComponent(variantData.sku) + '&handle=' + encodeURIComponent(productHandle);
      url += '&plan_ref=' + encodeURIComponent(variantData.planRef);
      return url;
    }

    function applyVariant(variantId) {
      var vd = purchaseData.variants[String(variantId)] || purchaseData.variants[variantId];
      if (!vd) return;

      if (onetimePriceEl) onetimePriceEl.textContent = money(vd.onetimePrice);

      if (vd.hasSubscription) {
        if (subRow) subRow.hidden = false;
        if (subPriceEl) subPriceEl.textContent = money(vd.subscriptionPrice);
        if (subCompareEl) {
          subCompareEl.textContent = money(vd.listPrice);
          subCompareEl.hidden = !(vd.listPrice > vd.subscriptionPrice);
        }
        if (subIntervalEl) {
          subIntervalEl.textContent = vd.interval === '2m' ? labels.intervalBimonthly : labels.intervalMonthly;
        }
        if (subPerksEl) {
          subPerksEl.textContent = vd.interval === '2m' ? labels.perksBi : labels.perks;
        }
        var pct = savingsPercent(vd.listPrice, vd.subscriptionPrice);
        if (subBadgeEl) {
          if (pct > 0) {
            subBadgeEl.hidden = false;
            subBadgeEl.textContent = formatSavings(labels.savings, pct);
          } else {
            subBadgeEl.hidden = true;
          }
        }
        var subRadio = purchaseRoot.querySelector('[data-vibee-pdp-purchase-mode-radio][value="subscription"]');
        if (subRadio && !subRadio.checked && getCheckedMode() === 'onetime') {
          /* keep user choice */
        }
      } else {
        if (subRow) subRow.hidden = true;
        var onetimeRadio = purchaseRoot.querySelector('[data-vibee-pdp-purchase-mode-radio][value="onetime"]');
        if (onetimeRadio) onetimeRadio.checked = true;
        state.mode = 'onetime';
        state.sellingPlan = '';
      }

      syncSelectedCards();
      if (callbacks && callbacks.onVariantApplied) callbacks.onVariantApplied(vd);
    }

    modeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        state.mode = radio.value === 'subscription' ? 'subscription' : 'onetime';
        state.bundleId = '';
        if (state.mode === 'subscription') {
          var variantId = section.querySelector('[data-vibee-pdp-variant-select]');
          var id = variantId ? variantId.value : section.querySelector('[data-vibee-pdp-variant-id]');
          id = id && id.value !== undefined ? id.value : id;
          var vd = purchaseData.variants[String(id)];
          state.sellingPlan = vd && vd.sellingPlanId ? String(vd.sellingPlanId) : '';
        } else {
          state.sellingPlan = '';
        }
        syncSelectedCards();
        updatePurchaseState(section, state);
        if (callbacks && callbacks.onModeChange) callbacks.onModeChange();
      });
    });

    return {
      applyVariant: applyVariant,
      getVariantData: function (variantId) {
        return purchaseData.variants[String(variantId)];
      },
      externalCheckoutUrl: externalCheckoutUrl,
      getShownPrice: function (variantId) {
        var vd = purchaseData.variants[String(variantId)];
        if (!vd) return state.basePrice;
        if (state.mode === 'subscription' && vd.hasSubscription) return vd.subscriptionPrice;
        return vd.onetimePrice;
      },
      getCtaPrefix: function () {
        return state.mode === 'subscription' ? labels.ctaSub : labels.ctaOnetime;
      },
      getCtaSuffix: function (variantId) {
        var vd = purchaseData.variants[String(variantId)];
        if (!vd || !vd.hasSubscription) return '';
        return vd.interval === '2m' ? labels.ctaSuffixBimonthly : labels.ctaSuffixMonthly;
      },
      syncSelectedCards: syncSelectedCards
    };
  }

  function initBeforeAfter(section) {
    var root = section.querySelector('[data-before-after]');
    if (!root) return;
    var buttons = root.querySelectorAll('.vibee-pdp__facet-btn');
    var cards = root.querySelectorAll('.vibee-pdp__before-card');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.getAttribute('data-facet');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        cards.forEach(function (card) {
          var facetValue = card.getAttribute('data-skin-type') || card.getAttribute('data-shade') || '';
          card.hidden = facet !== 'all' && facetValue !== facet;
        });
      });
    });
  }

  function initShadeSelector(section) {
    var root = section.querySelector('[data-vibee-shade-selector]');
    if (!root) return;
    var shadeButtons = root.querySelectorAll('[data-vibee-shade]');
    var variantSelect = section.querySelector('[data-vibee-pdp-variant-select]');
    if (!shadeButtons.length || !variantSelect) return;

    function setActive(btn) {
      shadeButtons.forEach(function (x) {
        x.classList.toggle('is-active', x === btn);
        if (x === btn) x.setAttribute('aria-current', 'true');
        else x.removeAttribute('aria-current');
      });
    }

    shadeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setActive(btn);
      });
    });
  }

  function initShadeQuiz(section) {
    var root = section.querySelector('[data-vibee-shadequiz]');
    if (!root) return;
    var openBtn = root.querySelector('[data-vibee-shadequiz-open]');
    var panel = root.querySelector('[data-vibee-shadequiz-panel]');
    var submit = root.querySelector('[data-vibee-shadequiz-submit]');
    var result = root.querySelector('[data-vibee-shadequiz-result]');
    var fields = root.querySelectorAll('[data-shadequiz-key]');
    var rulesUrl = root.getAttribute('data-rules-url');
    var rulesetId = root.getAttribute('data-ruleset-id');
    if (!openBtn || !panel || !submit || !result || !rulesUrl || !rulesetId) return;

    openBtn.addEventListener('click', function () {
      panel.hidden = false;
    });

    submit.addEventListener('click', function () {
      var answers = {};
      fields.forEach(function (field) {
        var key = field.getAttribute('data-shadequiz-key');
        answers[key] = (field.value || '').trim();
      });

      fetch(rulesUrl)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var ruleset = (json.rulesets || {})[rulesetId];
          if (!ruleset) return;
          var found = null;
          (ruleset.rules || []).forEach(function (rule) {
            if (found) return;
            var ok = true;
            Object.keys(rule.match || {}).forEach(function (k) {
              if (String(answers[k] || '') !== String(rule.match[k])) ok = false;
            });
            if (ok) found = rule.result;
          });
          var finalResult = found || ruleset.fallback || {};
          var shadeSku = String(finalResult.shadeSku || '').toUpperCase();
          var shadeButtons = section.querySelectorAll('[data-vibee-shade]');
          var target = null;
          shadeButtons.forEach(function (btn) {
            var variantId = btn.getAttribute('data-variant-id');
            if (!variantId || target) return;
            var opt = section.querySelector('[data-vibee-pdp-variant-select] option[value="' + variantId + '"]');
            if (!opt) return;
            var sku = (opt.getAttribute('data-sku') || '').toUpperCase();
            if (sku === shadeSku || sku.indexOf(shadeSku + '-') === 0 || shadeSku.indexOf(sku + '-') === 0) target = btn;
          });
          if (target) {
            target.click();
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
          result.hidden = false;
          result.innerHTML = '<strong>Senin tonun: ' + (finalResult.shadeLabelTr || '-') + '</strong><br><span>' + (finalResult.noteTr || '') + '</span>';
          try {
            sessionStorage.setItem('vibee-shade-quiz', JSON.stringify(answers));
          } catch (e) {}
        });
    });
  }

  function initQuiz(section) {
    var quizNode = section.querySelector('[data-vibee-quiz]');
    if (!quizNode) return;
    var openButton = quizNode.querySelector('[data-vibee-wa-open]');
    var modal = quizNode.querySelector('[data-vibee-wa-modal]');
    var closeButton = quizNode.querySelector('[data-vibee-wa-close]');
    var goButton = quizNode.querySelector('[data-vibee-wa-go]');
    var consent = quizNode.querySelector('[data-vibee-wa-consent]');
    var fields = quizNode.querySelectorAll('[data-quiz-key]');
    if (!openButton || !modal || !closeButton || !goButton || !consent) return;

    var rawNumber = String(modal.getAttribute('data-wa-number') || '');
    var number = rawNumber.replace(/[^\d]/g, '');

    function lockScroll() {
      document.body.classList.add('vibee-pdp--scroll-lock');
    }

    function unlockScroll() {
      document.body.classList.remove('vibee-pdp--scroll-lock');
    }

    function openModal() {
      modal.hidden = false;
      lockScroll();
    }

    function closeModal() {
      modal.hidden = true;
      unlockScroll();
    }

    function syncGoState() {
      var canGo = number && consent.checked;
      if (!number) {
        goButton.disabled = true;
      } else {
        goButton.disabled = !canGo;
      }
    }

    openButton.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
    consent.addEventListener('change', syncGoState);
    syncGoState();

    goButton.addEventListener('click', function () {
      if (!number || goButton.disabled) return;

      var payload = {};
      fields.forEach(function (field) {
        var key = field.getAttribute('data-quiz-key');
        var value = (field.value || '').trim();
        if (value) payload[key] = value;
      });

      var qpUrl = new URL(window.location.href);
      qpUrl.searchParams.set('quiz', encodeURIComponent(JSON.stringify(payload)));
      window.history.replaceState({}, '', qpUrl.toString());
      try {
        sessionStorage.setItem('vibee-wa-quiz', JSON.stringify(payload));
      } catch (e) {}

      var titleEl = section.querySelector('.vibee-pdp__title');
      var productTitle = titleEl ? titleEl.textContent.trim() : (document.title || '');
      var parts = ['Merhaba, cilt analizi istiyorum.'];
      if (payload.skinType) parts.push('Cilt tipim: ' + payload.skinType + '.');
      if (payload.concern) parts.push('Ana endişem: ' + payload.concern + '.');
      if (payload.routine) parts.push('Rutinim: ' + payload.routine + '.');
      parts.push('Ürün: ' + productTitle + '.');
      var msg = parts.join(' ');

      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(msg), '_blank');
    });
  }

  function initGallery(section) {
    var gallery = section.querySelector('[data-vibee-pdp-gallery]');
    if (!gallery) return null;

    var dataNode = gallery.querySelector('[data-vibee-pdp-gallery-data]');
    var items = [];
    try {
      if (dataNode) items = JSON.parse(dataNode.textContent).items || [];
    } catch (e) {
      console.error('vibee-pdp gallery JSON parse error', e);
    }
    if (!items.length) return null;

    var frame = gallery.querySelector('[data-vibee-pdp-gallery-frame]');
    var layerA = gallery.querySelector('[data-vibee-pdp-layer="a"]');
    var layerB = gallery.querySelector('[data-vibee-pdp-layer="b"]');
    var mobileTrack = gallery.querySelector('[data-vibee-pdp-mobile-track]');
    var counter = gallery.querySelector('[data-vibee-pdp-gallery-counter]');
    var thumbs = gallery.querySelectorAll('[data-vibee-pdp-thumb]');
    var indicator = gallery.querySelector('[data-vibee-pdp-thumb-indicator]');
    var activeIndex = 0;
    var frontLayer = layerA;
    var backLayer = layerB;
    var prefetched = {};

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function prefetchAround(index) {
      [-1, 0, 1].forEach(function (offset) {
        var i = index + offset;
        if (i < 0 || i >= items.length) return;
        var item = items[i];
        if (!item || item.type === 'video' || !item.src) return;
        if (prefetched[item.src]) return;
        prefetched[item.src] = true;
        var img = new Image();
        img.src = item.src;
      });
    }

    function renderImageLayer(layer, item) {
      layer.innerHTML = '';
      if (!item || item.type === 'video') return;
      var img = document.createElement('img');
      img.src = item.src1200 || item.src;
      img.alt = item.alt || '';
      img.className = 'vibee-pdp__gallery-image';
      img.setAttribute('data-vibee-pdp-main-image', '');
      img.sizes = '(min-width: 990px) min(50vw, 520px), 100vw';
      layer.appendChild(img);
    }

    function renderVideoLayer(layer, index) {
      layer.innerHTML = '';
      var slide = gallery.querySelector('[data-vibee-pdp-slide][data-index="' + index + '"]');
      if (!slide) return;
      var sourceVideo = slide.querySelector('video');
      if (!sourceVideo) return;
      var video = sourceVideo.cloneNode(true);
      video.className = 'vibee-pdp__gallery-video';
      video.controls = true;
      layer.appendChild(video);
    }

    function syncThumbs(index) {
      thumbs.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        if (active) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });

      if (indicator && thumbs[index]) {
        indicator.style.transform = 'translateY(' + thumbs[index].offsetTop + 'px)';
        indicator.style.height = thumbs[index].offsetHeight + 'px';
      }

      if (counter) counter.textContent = index + 1 + '/' + items.length;
      prefetchAround(index);
    }

    function crossfadeTo(index) {
      if (index < 0 || index >= items.length) return;
      activeIndex = index;
      syncThumbs(index);

      var item = items[index];
      var incoming = backLayer;
      var outgoing = frontLayer;

      if (item.type === 'video') renderVideoLayer(incoming, index);
      else renderImageLayer(incoming, item);

      outgoing.classList.remove('is-active');
      incoming.classList.add('is-incoming', 'is-active');

      window.setTimeout(function () {
        incoming.classList.remove('is-incoming');
        outgoing.classList.remove('is-active', 'is-incoming');
        outgoing.innerHTML = '';
        frontLayer = incoming;
        backLayer = outgoing;
      }, 280);
    }

    function scrollMobileTo(index) {
      if (!mobileTrack) return;
      var slide = mobileTrack.querySelector('[data-vibee-pdp-slide][data-index="' + index + '"]');
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    if (layerA) {
      if (items[0].type === 'video') renderVideoLayer(layerA, 0);
      else renderImageLayer(layerA, items[0]);
      layerA.classList.add('is-active');
    }
    syncThumbs(0);

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.getAttribute('data-index') || 0);
        if (isDesktop()) crossfadeTo(index);
        else scrollMobileTo(index);
      });
    });

    if (mobileTrack) {
      var scrollTimer;
      function syncFromScroll() {
        var slides = mobileTrack.querySelectorAll('[data-vibee-pdp-slide]');
        var trackRect = mobileTrack.getBoundingClientRect();
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var rect = slide.getBoundingClientRect();
          var dist = Math.abs(rect.left - trackRect.left);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        if (best !== activeIndex) {
          activeIndex = best;
          syncThumbs(best);
        }
      }
      mobileTrack.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(syncFromScroll, 80);
        },
        { passive: true },
      );
      mobileTrack.addEventListener('scrollend', syncFromScroll, { passive: true });
    }

    if (frame) {
      frame.addEventListener('mousemove', function (e) {
        if (!isDesktop()) return;
        var rect = frame.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        frame.querySelectorAll('.vibee-pdp__gallery-layer.is-active img').forEach(function (img) {
          img.style.transformOrigin = x + '% ' + y + '%';
        });
        frame.classList.add('is-zoom-ready');
      });
      frame.addEventListener('mouseleave', function () {
        frame.classList.remove('is-zoom-ready');
      });

      frame.addEventListener('keydown', function (e) {
        if (!isDesktop()) return;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          crossfadeTo(Math.max(0, activeIndex - 1));
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          crossfadeTo(Math.min(items.length - 1, activeIndex + 1));
        }
      });

      if (window.VibeeLightbox) {
        frame.addEventListener('click', function () {
          if (!isDesktop()) return;
          var item = items[activeIndex];
          if (!item || item.type === 'video') return;
          window.VibeeLightbox.open(items, activeIndex);
        });

        var lastTap = 0;
        frame.addEventListener('touchend', function () {
          var now = Date.now();
          if (now - lastTap < 300) {
            var item = items[activeIndex];
            if (item && item.type !== 'video') window.VibeeLightbox.open(items, activeIndex);
          }
          lastTap = now;
        });
      }
    }

    return {
      goTo: crossfadeTo,
      goToFeaturedMedia: function (mediaId) {
        if (!mediaId) return;
        var targetIndex = -1;
        for (var i = 0; i < items.length; i += 1) {
          if (String(items[i].id) === String(mediaId)) {
            targetIndex = i;
            break;
          }
        }
        if (targetIndex < 0) return;
        if (isDesktop()) crossfadeTo(targetIndex);
        else {
          activeIndex = targetIndex;
          syncThumbs(targetIndex);
          scrollMobileTo(targetIndex);
        }
      },
      getItems: function () { return items; },
    };
  }

  function initSection(section) {
    var variantSelect = section.querySelector('[data-vibee-pdp-variant-select]');
    var variantIdInputs = section.querySelectorAll('[data-vibee-pdp-variant-id]');
    var priceValueEls = section.querySelectorAll('[data-vibee-pdp-price-value]');
    var compareEls = section.querySelectorAll('[data-vibee-pdp-compare]');
    var atcButtons = section.querySelectorAll('[data-vibee-pdp-atc-button]');
    var stickyPrice = section.querySelector('[data-vibee-pdp-sticky-price]');
    var stickyCompare = section.querySelector('[data-vibee-pdp-sticky-compare]');
    var stickyMeta = section.querySelector('[data-vibee-pdp-sticky-meta]');
    var stickySubmit = section.querySelector('[data-vibee-pdp-sticky-submit]');
    var stickyModule = section.querySelector('.vibee-pdp__module--sticky-atc');
    var atcSentinel = section.querySelector('[data-vibee-pdp-atc-button]');
    var buyForm = section.querySelector('[data-vibee-pdp-atc-form]');
    var hasPurchaseSelector = buyForm && buyForm.hasAttribute('data-vibee-pdp-has-purchase-selector');
    var galleryApi = initGallery(section);

    var state = {
      mode: hasPurchaseSelector ? 'subscription' : 'onetime',
      sellingPlan: '',
      bundleId: '',
      basePrice: 0,
      variantTitle: '',
      variantId: ''
    };

    var purchaseSelector = hasPurchaseSelector
      ? initPurchaseSelector(section, state, {
          onModeChange: function () { updateVisiblePrices(); },
          onVariantApplied: function (vd) {
            if (state.mode === 'subscription' && vd.hasSubscription) {
              state.sellingPlan = vd.sellingPlanId ? String(vd.sellingPlanId) : '';
            } else if (!vd.hasSubscription) {
              state.sellingPlan = '';
            }
            updatePurchaseState(section, state);
            updateVisiblePrices();
          }
        })
      : null;

    updatePurchaseState(section, state);

    function subscriptionPriceSuffix(variantId) {
      if (!purchaseSelector || !variantId || state.mode !== 'subscription') return '';
      return purchaseSelector.getCtaSuffix(variantId);
    }

    function resolvePurchaseAction() {
      if (state.mode === 'subscription' && purchaseSelector) {
        var vd = purchaseSelector.getVariantData(state.variantId);
        if (vd && vd.hasSubscription && vd.planRef && !vd.sellingPlanId && vd.externalCheckout) {
          return 'external';
        }
      }
      return 'submit';
    }

    function goExternal() {
      if (!purchaseSelector) return false;
      var vd = purchaseSelector.getVariantData(state.variantId);
      var url = purchaseSelector.externalCheckoutUrl(vd);
      if (!url) {
        console.error('vibee-pdp: external checkout URL boş (sku eksik?)', state.variantId);
        return false;
      }
      window.location.assign(url);
      return true;
    }

    if (buyForm) {
      buyForm.addEventListener('submit', function (event) {
        if (buyForm.dataset.vibeeNativeFallback === '1') {
          buyForm.dataset.vibeeNativeFallback = '0';
          buyForm.dataset.cartAdding = '0';
          return;
        }

        event.preventDefault();
        if (buyForm.dataset.cartAdding === '1') return;

        if (purchaseSelector && resolvePurchaseAction() === 'external') {
          goExternal();
          return;
        }

        buyForm.dataset.cartAdding = '1';
        var payload = buildCartAddPayloadFromForm(buyForm);
        var triggerButtons = Array.prototype.slice.call(atcButtons);
        if (stickySubmit) triggerButtons.push(stickySubmit);
        triggerButtons.forEach(function (btn) {
          btn.disabled = true;
        });

        vibeeCartAddAndSync({
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        })
          .catch(function (err) {
            if (isCartAddNetworkError(err)) {
              buyForm.dataset.vibeeNativeFallback = '1';
              buyForm.dataset.cartAdding = '0';
              triggerButtons.forEach(function (btn) {
                btn.disabled = false;
              });
              safeSubmit(buyForm);
              return;
            }
            if (window.vibeeCartDrawer && typeof window.vibeeCartDrawer.showError === 'function') {
              window.vibeeCartDrawer.showError();
            }
            triggerButtons.forEach(function (btn) {
              btn.textContent = 'Sepete eklenemedi — tekrar dene';
            });
            window.setTimeout(function () {
              syncVariant();
            }, 3200);
          })
          .finally(function () {
            if (buyForm.dataset.vibeeNativeFallback === '1') return;
            buyForm.dataset.cartAdding = '0';
            syncVariant();
          });
      });
    }

    function updateVisiblePrices() {
      var variantId = state.variantId;
      var shownPrice = state.basePrice;
      var ctaPrefix = 'Sepete ekle';

      if (purchaseSelector && variantId) {
        shownPrice = purchaseSelector.getShownPrice(variantId);
        ctaPrefix = purchaseSelector.getCtaPrefix();
      } else if (state.mode === 'subscription') {
        shownPrice = state.basePrice;
      }

      priceValueEls.forEach(function (el) { el.textContent = money(shownPrice); });

      if (stickyPrice) {
        var stickyPriceText = money(shownPrice);
        if (purchaseSelector && variantId && state.mode === 'subscription') {
          var vdSticky = purchaseSelector.getVariantData(variantId);
          if (vdSticky && vdSticky.hasSubscription) {
            stickyPriceText = stickyPriceText + subscriptionPriceSuffix(variantId);
          }
        }
        stickyPrice.textContent = stickyPriceText;
      }

      if (stickyMeta) {
        var stickyTitle = stickyMeta.getAttribute('data-vibee-pdp-sticky-title') || stickyMeta.textContent || '';
        stickyMeta.textContent = stickyTitle;
      }

      atcButtons.forEach(function (btn) {
        if (!btn.disabled) {
          btn.textContent = ctaPrefix + ' — ' + money(shownPrice) + subscriptionPriceSuffix(variantId);
        }
      });

      if (stickySubmit && !stickySubmit.disabled) {
        var stickyMod = section.querySelector('.vibee-pdp__module--sticky-atc');
        var stickyLabel = stickyMod
          ? (state.mode === 'subscription' && purchaseSelector
            ? (stickyMod.getAttribute('data-label-sticky-sub') || 'DÜZENLİ TESLİMATLA AL')
            : (stickyMod.getAttribute('data-label-sticky-onetime') || 'SEPETE EKLE'))
          : 'SEPETE EKLE';
        stickySubmit.textContent = stickyLabel;
      }
    }

    function syncGalleryForVariant(selectedOption) {
      if (!galleryApi || !selectedOption) return;
      var mediaId = selectedOption.getAttribute('data-featured-media-id');
      if (mediaId) galleryApi.goToFeaturedMedia(mediaId);
    }

    function syncVariant() {
      if (!variantSelect) {
        var hiddenId = section.querySelector('[data-vibee-pdp-variant-id]');
        if (hiddenId) {
          state.variantId = hiddenId.value;
          var singlePrice = Number(hiddenId.getAttribute('data-price') || 0);
          var singleCompare = Number(hiddenId.getAttribute('data-compare') || 0);
          if (singlePrice) state.basePrice = singlePrice;
          compareEls.forEach(function (el) {
            if (singleCompare > singlePrice) {
              el.textContent = money(singleCompare);
              el.hidden = false;
            } else {
              el.hidden = true;
            }
          });
          if (stickyCompare) {
            if (singleCompare > singlePrice) {
              stickyCompare.textContent = money(singleCompare);
              stickyCompare.hidden = false;
            } else {
              stickyCompare.hidden = true;
            }
          }
        }
        if (purchaseSelector && state.variantId) purchaseSelector.applyVariant(state.variantId);
        updateVisiblePrices();
        return;
      }

      var selected = variantSelect.options[variantSelect.selectedIndex];
      if (!selected) return;
      var variantId = selected.value;
      var price = Number(selected.getAttribute('data-price') || 0);
      var compare = Number(selected.getAttribute('data-compare') || 0);
      var available = String(selected.getAttribute('data-available')) === 'true';
      var title = selected.getAttribute('data-title') || '';

      state.basePrice = price;
      state.variantTitle = title;
      state.variantId = variantId;

      if (purchaseSelector) {
        purchaseSelector.applyVariant(variantId);
        var vd = purchaseSelector.getVariantData(variantId);
        if (vd && state.mode === 'subscription' && vd.hasSubscription) {
          state.sellingPlan = vd.sellingPlanId ? String(vd.sellingPlanId) : '';
        } else if (!vd || !vd.hasSubscription || state.mode !== 'subscription') {
          if (!vd || !vd.hasSubscription) state.sellingPlan = '';
        }
        updatePurchaseState(section, state);
      }

      variantIdInputs.forEach(function (input) { input.value = variantId; });
      compareEls.forEach(function (el) {
        if (compare > price) {
          el.textContent = money(compare);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      if (stickyCompare) {
        if (compare > price) {
          stickyCompare.textContent = money(compare);
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }

      atcButtons.forEach(function (btn) {
        btn.disabled = !available;
        if (!available) btn.textContent = 'Tükendi';
      });
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        if (!available) stickySubmit.textContent = 'Tükendi';
      }

      updateVisiblePrices();
      syncGalleryForVariant(selected);
    }

    variantSelect && variantSelect.addEventListener('change', syncVariant);
    syncVariant();

    section.querySelectorAll('[data-vibee-pdp-bundle-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.dataset.loading === '1') return;
        var root = section.querySelector('[data-vibee-bundle]');
        var items = [];
        if (root) {
          var seedHandle = root.getAttribute('data-seed-handle') || '';
          var buddyHandle = root.getAttribute('data-buddy-handle') || '';
          var buddySelected = false;
          root.querySelectorAll('[data-bundle-item]').forEach(function (c) {
            var id = c.getAttribute('data-id');
            if (!c.checked || !id) return;
            if (c.getAttribute('data-seed') !== 'true') buddySelected = true;
            items.push({ id: Number(id), quantity: 1 });
          });
          if (buddySelected && items.length >= 2 && seedHandle && buddyHandle) {
            var bundleId = seedHandle + '__' + buddyHandle;
            items = items.map(function (item) {
              return {
                id: item.id,
                quantity: item.quantity,
                properties: { _bundle_id: bundleId }
              };
            });
          }
        }
        if (!items.length) return;
        btn.dataset.loading = '1';
        var lbl = btn.querySelector('[data-bundle-cta-label]');
        var prev = lbl ? lbl.textContent : '';
        if (lbl) lbl.textContent = root ? (root.getAttribute('data-label-adding') || 'Ekleniyor…') : 'Ekleniyor…';
        vibeeCartAddAndSync({
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items }),
        })
          .then(function () {
            if (lbl) lbl.textContent = prev;
          })
          .catch(function () {
            if (window.vibeeCartDrawer && typeof window.vibeeCartDrawer.showError === 'function') {
              window.vibeeCartDrawer.showError(
                root
                  ? root.getAttribute('data-label-error') || undefined
                  : undefined,
              );
            }
            if (lbl) {
              lbl.textContent = root
                ? root.getAttribute('data-label-error') || 'Sepete eklenemedi — tekrar dene'
                : 'Sepete eklenemedi — tekrar dene';
              window.setTimeout(function () {
                if (lbl) lbl.textContent = prev;
              }, 3200);
            }
          })
          .finally(function () {
            btn.dataset.loading = '0';
          });
      });
    });

    if (stickySubmit && buyForm) {
      stickySubmit.addEventListener('click', function () {
        if (purchaseSelector && resolvePurchaseAction() === 'external') {
          goExternal();
          return;
        }
        safeSubmit(buyForm);
      });
    }

    if (stickyModule && atcSentinel && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        stickyModule.classList.toggle('is-visible', !entries[0].isIntersecting);
        if (typeof window.vibeeSyncStickyAtcHeight === 'function') {
          window.requestAnimationFrame(window.vibeeSyncStickyAtcHeight);
        }
      }, { threshold: 0, rootMargin: '0px' });
      stickyObserver.observe(atcSentinel);
    }

    var bundleRoot = section.querySelector('[data-vibee-bundle]');
    if (bundleRoot) {
      var checks = bundleRoot.querySelectorAll('[data-bundle-item]');
      var totalNode = bundleRoot.querySelector('[data-bundle-total]');
      var actionsNode = bundleRoot.querySelector('[data-bundle-actions]');
      var ctaBtn = bundleRoot.querySelector('[data-vibee-pdp-bundle-select]');
      var unlockQty = Number(bundleRoot.getAttribute('data-bundle-unlock-qty') || 2);
      var unlockPct = Number(bundleRoot.getAttribute('data-bundle-unlock-pct') || 15);
      var clubMultiplier = Number(bundleRoot.getAttribute('data-club-multiplier') || 5);
      var labelCta = bundleRoot.getAttribute('data-label-cta') || 'SETİ SEPETE EKLE';
      var labelDiscount = bundleRoot.getAttribute('data-label-discount') || '{{ percent }} indirim · {{ savings }} tasarruf';
      var labelClub = bundleRoot.getAttribute('data-label-club') || 'Set ile ~{{ points }} Vibees+ puanı kazanırsın';

      function formatClubPoints(priceCents) {
        var priceTl = Math.floor(Number(priceCents || 0) / 100);
        var rawPoints = priceTl * clubMultiplier;
        var remainder = rawPoints % 50;
        var points = rawPoints - remainder;
        if (remainder >= 25) points += 50;
        return points;
      }

      function formatTrInteger(n) {
        var s = String(Math.max(0, Math.floor(Number(n || 0))));
        return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }

      function syncCheckVisual(input) {
        var item = input.closest ? input.closest('.vibee-pdp__bundle-item') : null;
        if (!item) return;
        var checked = input.checked || input.disabled;
        item.classList.toggle('is-selected', checked);
        var toggleBtn = item.querySelector('[data-bundle-toggle]');
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-pressed', checked ? 'true' : 'false');
          var label = checked ? toggleBtn.getAttribute('data-label-remove') : toggleBtn.getAttribute('data-label-add');
          if (label) toggleBtn.setAttribute('aria-label', label);
        }
      }

      function recalcBundle() {
        var discountedNode = bundleRoot.querySelector('[data-bundle-discounted]');
        var badgeNode = bundleRoot.querySelector('[data-bundle-badge]');
        var clubNode = bundleRoot.querySelector('[data-bundle-club-points]');
        var count = 0;
        var ham = 0;
        checks.forEach(function (c) {
          syncCheckVisual(c);
          if (!c.checked) return;
          count += 1;
          ham += Number(c.getAttribute('data-price') || 0);
        });
        var discountPct = count >= unlockQty ? unlockPct : 0;
        var discounted = Math.floor(ham * (1 - discountPct / 100));
        var savings = ham - discounted;
        var isActive = discountPct > 0;

        if (totalNode) {
          totalNode.textContent = moneyFloor(ham);
          totalNode.hidden = !isActive;
        }
        if (discountedNode) {
          discountedNode.textContent = moneyFloor(discounted);
        }
        if (badgeNode) {
          if (isActive) {
            badgeNode.hidden = false;
            badgeNode.textContent = labelDiscount
              .replace(/\{\{\s*percent\s*\}\}/g, '%' + String(discountPct))
              .replace(/\{\{\s*savings\s*\}\}/g, moneyFloor(savings));
          } else {
            badgeNode.hidden = true;
          }
        }
        if (clubNode) {
          var pts = formatClubPoints(isActive ? discounted : 0);
          clubNode.textContent = labelClub.replace(/\{\{\s*points\s*\}\}/g, formatTrInteger(pts));
        }
        if (actionsNode) {
          actionsNode.classList.toggle('is-disabled', !isActive);
        }
        if (ctaBtn) {
          ctaBtn.disabled = !isActive;
        }
      }

      checks.forEach(function (c) {
        c.addEventListener('change', recalcBundle);
        syncCheckVisual(c);
      });

      // Circular +/✓ button toggles the hidden checkbox; recalcBundle
      // listens on the input's change event, so cart add logic is untouched.
      bundleRoot.querySelectorAll('[data-bundle-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.vibee-pdp__bundle-item');
          var input = item ? item.querySelector('[data-bundle-item]') : null;
          if (!input || input.disabled) return;
          input.checked = !input.checked;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      recalcBundle();
    }

    initBeforeAfter(section);
    initQuiz(section);
    initShadeSelector(section);
    initShadeQuiz(section);
  }

  document.querySelectorAll('[data-vibee-pdp]').forEach(function (section) {
    try {
      initSection(section);
    } catch (e) {
      console.error('vibee-pdp: section init failed', e);
    }
  });

  // Back-in-stock lead capture. TODO: replace mailto fallback with a real
  // back-in-stock backend (Klaviyo / Shopify "Notify me") POST.
  function initBackInStock(form) {
    if (form.dataset.vibeeBisInit === 'true') return;
    form.dataset.vibeeBisInit = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = input ? String(input.value || '').trim() : '';
      if (!email) return;
      var root = form.closest('[data-back-in-stock]');
      var shopEmail = form.getAttribute('data-shop-email') || '';
      var productId = root ? root.getAttribute('data-product-id') : '';
      var variantId = root ? root.getAttribute('data-variant-id') : '';
      if (shopEmail) {
        var subject = 'Stok bildirimi talebi';
        var body =
          'Stoğa gelince haber verin.%0D%0AE-posta: ' +
          encodeURIComponent(email) +
          '%0D%0AÜrün ID: ' +
          encodeURIComponent(productId || '') +
          '%0D%0AVaryant ID: ' +
          encodeURIComponent(variantId || '');
        window.location.href =
          'mailto:' + shopEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + body;
      }
      form.hidden = true;
      if (root) {
        var done = root.querySelector('[data-vibee-bis-done]');
        if (done) done.hidden = false;
      }
    });
  }

  document.querySelectorAll('[data-vibee-bis-form]').forEach(initBackInStock);
})();
